import { getEnvVariable } from './getEnvVariable';

export const isDev = getEnvVariable('CI_ENVIRONMENT_NAME') === 'localdev';
